import { render, staticRenderFns } from "./arbo_web_summary.vue?vue&type=template&id=512ea6e2&"
import script from "./arbo_web_summary.vue?vue&type=script&lang=js&"
export * from "./arbo_web_summary.vue?vue&type=script&lang=js&"
import style0 from "./arbo_web_summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports